import * as AlertDialog from '@radix-ui/react-alert-dialog'
import { cx } from '../util/cx'
import Button from './Button'
import styles from './Modal.module.css'

interface AlertDialogModalProps {
  open: boolean
  onClose: () => void
  title: string
  description: React.ReactNode
  confirmLabel: string
  cancelLabel?: string
  danger?: boolean
  onConfirm: () => void
}

export default function AlertDialogModal({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  danger,
  onConfirm,
}: AlertDialogModalProps) {
  return (
    <AlertDialog.Root open={open} onOpenChange={(next) => !next && onClose()}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className={styles.backdrop} />
        <AlertDialog.Content className={styles.panel}>
          <div className={styles.header}>
            <AlertDialog.Title className={styles.title}>{title}</AlertDialog.Title>
          </div>
          <AlertDialog.Description className={cx(styles.body, styles.message)}>
            {description}
          </AlertDialog.Description>
          <div className={styles.footer}>
            <AlertDialog.Cancel asChild>
              <Button variant='ghost'>{cancelLabel}</Button>
            </AlertDialog.Cancel>
            <AlertDialog.Action asChild>
              <Button variant={danger ? 'primary' : 'blue'} onClick={onConfirm}>
                {confirmLabel}
              </Button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
